/* eslint-disable */
import { CONFIG } from "config";

const GOOGLE_ANALYTICS_ID = "G-H3PQ7WRDC6";

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  const numParts = 2;
  if (parts.length === numParts) {
    return parts.pop().split(";").shift();
  }
  return null;
}
const SHOULD_TRACK = getCookie("DoNotTrack") !== "true";

// Marketing is using Google Analytics, so don't remove this
// Global site tag (gtag.js) - Google Analytics
if (SHOULD_TRACK && CONFIG.APP_ENV === "production") {
  const script = document.createElement("script");
  script.setAttribute("async", "true");
  script.setAttribute(
    "src",
    `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`
  );
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  gtag("js", new Date());
  gtag("config", GOOGLE_ANALYTICS_ID);
}

function gtag() {
  window.dataLayer.push(arguments);
}

// QUALTRICS Contact Frequency Rules for Intercepts
let emailAddress = "";
const usernameCookie = getCookie("mss-username");

//Encoding pattern seems to have changed
//Adding try/catch to make sure legacy implementation doesn't break
if (usernameCookie) {
  try {
    emailAddress = atob(usernameCookie.slice(0, -3) + "=");
  } catch (e) {
    emailAddress = atob(decodeURIComponent(usernameCookie));
  }
}
if (typeof window.QSI === "undefined") {
  window.QSI = {};
  window.QSI.config = {
    externalReference: emailAddress,
  };
}

// BEGIN QUALTRICS WEBSITE FEEDBACK SNIPPET
(function () {
  var g = function (e, h, f, g) {
    this.get = function (a) {
      for (
        var a = a + "=", c = document.cookie.split(";"), b = 0, e = c.length;
        b < e;
        b++
      ) {
        for (var d = c[b]; " " == d.charAt(0); ) d = d.substring(1, d.length);
        if (0 == d.indexOf(a)) return d.substring(a.length, d.length);
      }
      return null;
    };
    this.set = function (a, c) {
      var b = "",
        b = new Date();
      b.setTime(b.getTime() + 6048e5);
      b = "; expires=" + b.toGMTString();
      document.cookie = a + "=" + c + b + "; path=/; ";
    };
    this.check = function () {
      var a = this.get(f);
      if (a) a = a.split(":");
      else if (100 != e)
        "v" == h && (e = Math.random() >= e / 100 ? 0 : 100),
          (a = [h, e, 0]),
          this.set(f, a.join(":"));
      else return !0;
      var c = a[1];
      if (100 == c) return !0;
      switch (a[0]) {
        case "v":
          return !1;
        case "r":
          return (
            (c = a[2] % Math.floor(100 / c)),
            a[2]++,
            this.set(f, a.join(":")),
            !c
          );
      }
      return !0;
    };
    this.go = function () {
      if (this.check()) {
        var a = document.createElement("script");
        a.type = "text/javascript";
        a.src = g;
        document.body && document.body.appendChild(a);
      }
    };
    this.start = function () {
      var t = this;
      "complete" !== document.readyState
        ? window.addEventListener
          ? window.addEventListener(
              "load",
              function () {
                t.go();
              },
              !1
            )
          : window.attachEvent &&
            window.attachEvent("onload", function () {
              t.go();
            })
        : t.go();
    };
  };
  try {
    new g(
      100,
      "r",
      `QSI_S_${CONFIG.QUALTRICS_PROJECT_ID}`,
      `https://${CONFIG.QUALTRICS_PROJECT_ID.replace(
        "_",
        ""
      ).toLowerCase()}-sagesure.siteintercept.qualtrics.com/SIE/?Q_ZID=${
        CONFIG.QUALTRICS_PROJECT_ID
      }`
    ).start();
  } catch (i) {}
})();
// END QUALTRICS WEBSITE FEEDBACK SNIPPET
